import React from "react"
import { BdTitle5, RegBody, SemiBdTitle5 } from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

export interface ProductEntryHowItWorksCardProps {
  number: number
  body: string
  title: string
}

const ProductEntryHowItWorksCard = ({
  number = 1,
  title = "Title",
  body = "Body",
}: ProductEntryHowItWorksCardProps) => {
  return (
    <ProductEntryHowItWorksCardStyled>
      <div className="product-entry-how-it-works__card-icon-container">
        <BdTitle5 className="product-entry-how-it-works__card-icon-number">
          {number}
        </BdTitle5>
      </div>
      <div className="product-entry-how-it-works__card-text-container">
        <SemiBdTitle5 className="product-entry-how-it-works__card-title">
          {title}
        </SemiBdTitle5>
        <RegBody className="product-entry-how-it-works__card-body">
          {body}
        </RegBody>
      </div>
    </ProductEntryHowItWorksCardStyled>
  )
}

export default ProductEntryHowItWorksCard

const ProductEntryHowItWorksCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  box-shadow: 0px 4px 8px rgba(45, 50, 57, 0.2);
  border-radius: ${rem(8)};
  padding: ${rem(24)} ${rem(24)} ${rem(24)};

  @media ${media.midUp} {
    flex-direction: row;
    padding: ${rem(24)} ${rem(32)} ${rem(24)};
    gap: ${rem(24)};
  }
  @media ${media.stMidUp} {
    width: ${rem(280)};
    flex-direction: column;
    gap: ${rem(16)};
    padding: ${rem(24)} ${rem(24)} ${rem(32)};
  }

  .product-entry-how-it-works__card-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${rem(48)};
    height: ${rem(48)};
    border-radius: ${rem(48)};
    border: 1px solid var(--color-gray300);

    .product-entry-how-it-works__card-icon-number {
      color: var(--color-gray300);
      font-size: ${rem(24)};
    }
  }

  .product-entry-how-it-works__card-text-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};

    @media ${media.midUp} {
      padding-top: ${rem(8)};
    }

    @media ${media.stMidUp} {
      padding-top: 0;
    }

    .product-entry-how-it-works__card-title {
      color: var(--color-primary);
      font-size: ${rem(24)};
      line-height: ${rem(32)};
      max-width: ${rem(294)};

      @media ${media.midUp} {
        max-width: ${rem(512)};
      }

      @media ${media.stMidUp} {
        max-width: ${rem(217)};
      }
    }

    .product-entry-how-it-works__card-body {
      @media ${media.midUp} {
        max-width: ${rem(443)};
      }
    }
  }
`
